import { RouteStore } from 'fluxible-router';
import routes from '../configs/routes';

export default RouteStore.withStaticRoutes(routes);



// WEBPACK FOOTER //
// ./src/stores/RouteStore.js